import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';

import ExportButton from './ExportButton';

const ReportTable = ({
  title, 
  columns, 
  rows,
  fontSize = '0.875rem',
}) => {
  return (
    <Paper 
      sx={{
        width: 'auto',
        display: {xs: 'none', sm: 'block'},
        padding: 2,
        overflowX: 'scroll',
      }}
      elevation={0}
    >
      <TableContainer>
        <Stack direction='row' justifyContent='space-between' alignItems='center' mb={2}>
          {!!title && <Typography variant='h3'>
            {title}
            </Typography>
          }
          <ExportButton
            reportName={title || 'report'}
            rows={rows}
          />
        </Stack>
        <Table>
          <TableHead>
            <TableRow>
              {columns?.map(col => (
                <TableCell
                  key={col.key}
                  align={col.align || col.data_type === 'number' ? 'right' : 'left'}
                  style={{
                    minWidth: col.minWidth || 'auto',
                    width: 'auto',
                    fontSize,
                    borderRight: col?.formatting?.borderRight ? '1px solid #e1e1e1' : null,
                  }}
                >
                  {col.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {/* Table rows would go here */}
            {rows?.map((row, rowIndex) => (
              <TableRow key={rowIndex}>
                {columns.map(col => (
                  <TableCell
                    key={col.key}
                    align={col.align || ['integer', 'float', 'number'].includes(col.data_type) ? 'center' : 'left'}
                    style={{
                      fontSize,
                      color: col?.formatting?.mapper === 'percentage' ? 'rgb(150, 150, 150)' : null,
                      fontWeight: col?.formatting?.mapper === 'boldText' ? 'bold' : null,
                      borderRight: col?.formatting?.borderRight ? '1px solid #e1e1e1' : null,
                    }}
                  >
                    {row[col.key]}
                    {col?.formatting?.mapper === 'percentage' && '%'}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default ReportTable;